<div class="text_black border_wrapper h-100 powertrain_wrapper summaryBox">
  <div
    class="p-4 d-flex align-items-center justify-content-between text-black h_20 gap_10"
    style="
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
    "
  >
    <h4 class="font-weight-bolder powertrain_headers">
      Powertrain False Claims
    </h4>
    <button mat-raised-button color="primary" class="" (click)="updateFalseClaimsMetrics()">
      Update
    </button>
  </div>
  <div class="d-flex h_75" style="justify-content: space-around">
    <div class="mt-2 ml-4 flex flex_50 gap_10">
      <div class="column_response_text_left w-100 h_20">False Positives*</div>
      <div class="column_response_text_left w-100 h_20">False Negatives*</div>
      <div class="column_response_text_left w-100 h_20">CbM System Uptime</div>
    </div>
    <div
      class="mt-2 mr-4 flex flex_50 gap_10"
      *ngIf="!false_Claims_metrics_loader"
    >
      <div class="column_response_text_right h_20 text-center w-100">
        <!-- {{ false_Claims_metrics.positives }} --> N/A
      </div>
      <div class="column_response_text_right h_20 text-center w-100">
        <!-- {{ false_Claims_metrics.negatives }} --> N/A
      </div>
      <div class="column_response_text_right h_20 text-center w-100">
        <!-- {{ false_Claims_metrics.uptime }} --> N/A
      </div>
    </div>
    <div
      class="mt-2 flex flex_50 gap_10"
      *ngIf="false_Claims_metrics_loader"
      style="gap: 16px"
    >
      <div class="skeleton skeleton-text w-100"></div>
      <div class="skeleton skeleton-text w-100"></div>
      <div class="skeleton skeleton-text w-100"></div>
    </div>
  </div>
</div>

<app-powertrain-modal
  [type]="'falseClaimsMetrics'"
  [data]="false_Claims_metrics"
  *ngIf="showModal"
  (closeBox)="closeBox($event)"
></app-powertrain-modal>
